const CLEVERTAP_EVENT_NAMES = {
  Page_Viewed_Landing_Page: 'Page_Viewed_Landing_Page',
  Category_selected: 'Category_selected',
  Category_changed: 'Category_changed',
  Added_to_Cart: 'Added_to_Cart',
  PDP_Viewed: 'PDP_Viewed',
  Added_to_Closet: 'Added_to_Closet',
  Charged: 'Charged',
  Product_Viewed: 'Product_Viewed', // new event
  PDP_Interaction: 'PDP_Interaction',
  Cart_View: 'Cart_View',
  Change_Quantity: 'Change_Quantity',
  Change_Size: 'Change_Size',
  PLP_Viewed: 'PLP_Viewed',
  Search: 'Search',
  Saved_to_Closet: 'Saved_to_Closet',
  View_Closet: 'View_Closet',
  Remove_From_Closet: 'Remove_From_Closet',
  Address_Added: 'Address_Added',
  Purchase_Now: 'Purchase_Now',
  Payment_Initiated: 'Payment_Initiated',
  Removed_From_Cart: 'Removed_From_Cart',
  Shipping_Page_View: 'Shipping_Page_View',
  Order_Status_Cancelled: 'Order_Status_Cancelled',
  User_Sign_In: 'User_Sign_In',
  User_Sign_Up: 'User_Sign_Up',
  View_cart: 'View_cart',
  View_wishlist: 'View_wishlist',
  Added_to_cart: 'Added_to_cart',
  Add_to_closet: 'Add_to_closet',
  Checkout_initiated: 'Checkout_initiated',
  Payement_initiated: 'Payement_initiated',
  Notify_Me: 'notify_me_coming_soon'
};

export default CLEVERTAP_EVENT_NAMES;
